import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { ITaskData } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import { Task } from "fhir/r5";

/**
 * Cria uma nova tarefa
 * @param taskInformation Informações da tarefa a ser criada
 * @returns Task criada
 */
export async function PostTask(taskInformation: ITaskData): Promise<Task | any> {
  const data = auxiliarData.Task(taskInformation);
  const url = `${endpoints.WORKFLOWFHIR}/Task`;

  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  
  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Success &&
        response.status !== HTTPResponseStatus.Created
      ) {
        throw new Error(`PostTask: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostTask ", error);
      // toast.error(`PostTask Error: ${error?.response?.status}`);
      throw new Error();
    });
  
  if (response) return response;
}